import { IStartArcLiveParams } from '@common/interfaces/arcLive'
import { ISpeakerPick } from '@common/interfaces/callSpeaker'
import { IApi } from '../../api'
import { createRequestTypes } from '../../helpers/helpers'
import { createAction } from '../types'

export const prefix = 'arcLive'

export const [LIST_LIVE_MEETINGS_REQUEST, LIST_LIVE_MEETINGS_SUCCESS, LIST_LIVE_MEETINGS_FAILURE] =
  createRequestTypes(prefix, 'LIST_LIVE_MEETINGS')

export const listLiveMeetings = createAction(() => ({
  type: [LIST_LIVE_MEETINGS_REQUEST, LIST_LIVE_MEETINGS_SUCCESS, LIST_LIVE_MEETINGS_FAILURE],
  promise: (api: IApi) => api.arcLive.listLiveMeetings(),
}))

export const [START_ARC_LIVE_REQUEST, START_ARC_LIVE_SUCCESS, START_ARC_LIVE_FAILURE] =
  createRequestTypes(prefix, 'START_ARC_LIVE')

export const startArcLive = createAction((params: IStartArcLiveParams) => ({
  type: [START_ARC_LIVE_REQUEST, START_ARC_LIVE_SUCCESS, START_ARC_LIVE_FAILURE],
  promise: (api: IApi) => api.arcLive.start(params),
  params,
}))

export const [STOP_ARC_LIVE_REQUEST, STOP_ARC_LIVE_SUCCESS, STOP_ARC_LIVE_FAILURE] =
  createRequestTypes(prefix, 'STOP_ARC_LIVE')

/** Stops Arc following the call; starting it again resumes the same session. */
export const stopArcLive = createAction((id: string) => ({
  type: [STOP_ARC_LIVE_REQUEST, STOP_ARC_LIVE_SUCCESS, STOP_ARC_LIVE_FAILURE],
  promise: (api: IApi) => api.arcLive.stop(id),
  params: { id },
}))

export const [
  GET_ARC_LIVE_SESSION_REQUEST,
  GET_ARC_LIVE_SESSION_SUCCESS,
  GET_ARC_LIVE_SESSION_FAILURE,
] = createRequestTypes(prefix, 'GET_ARC_LIVE_SESSION')

export const getArcLiveSession = createAction((id: string) => ({
  type: [GET_ARC_LIVE_SESSION_REQUEST, GET_ARC_LIVE_SESSION_SUCCESS, GET_ARC_LIVE_SESSION_FAILURE],
  promise: (api: IApi) => api.arcLive.getSession(id),
  params: { id },
}))

export const [
  REQUEST_ARC_LIVE_NOTE_REQUEST,
  REQUEST_ARC_LIVE_NOTE_SUCCESS,
  REQUEST_ARC_LIVE_NOTE_FAILURE,
] = createRequestTypes(prefix, 'REQUEST_ARC_LIVE_NOTE')

/** Asks Arc to dig into one line of the transcript. */
export const requestArcLiveNote = createAction((id: string, chunkId: string) => ({
  type: [
    REQUEST_ARC_LIVE_NOTE_REQUEST,
    REQUEST_ARC_LIVE_NOTE_SUCCESS,
    REQUEST_ARC_LIVE_NOTE_FAILURE,
  ],
  promise: (api: IApi) => api.arcLive.requestNote(id, chunkId),
  params: { id, chunkId },
}))

export const [LIST_CALL_SPEAKERS_REQUEST, LIST_CALL_SPEAKERS_SUCCESS, LIST_CALL_SPEAKERS_FAILURE] =
  createRequestTypes(prefix, 'LIST_CALL_SPEAKERS')

/** Who each speaker on a call is, as far as we know. */
export const listCallSpeakers = createAction((meetingId: string) => ({
  type: [LIST_CALL_SPEAKERS_REQUEST, LIST_CALL_SPEAKERS_SUCCESS, LIST_CALL_SPEAKERS_FAILURE],
  promise: (api: IApi) => api.callSpeakers.list(meetingId),
  params: { meetingId },
}))

export const [SET_CALL_SPEAKER_REQUEST, SET_CALL_SPEAKER_SUCCESS, SET_CALL_SPEAKER_FAILURE] =
  createRequestTypes(prefix, 'SET_CALL_SPEAKER')

/** Says who a speaker is; kept for good. */
export const setCallSpeaker = createAction(
  (meetingId: string, speakerName: string, pick: ISpeakerPick) => ({
    type: [SET_CALL_SPEAKER_REQUEST, SET_CALL_SPEAKER_SUCCESS, SET_CALL_SPEAKER_FAILURE],
    promise: (api: IApi) => api.callSpeakers.set(meetingId, { speakerName, ...pick }),
    params: { meetingId, speakerName, ...pick },
  }),
)

export const OPEN_ARC_LIVE_PANEL = `${prefix}/OPEN_ARC_LIVE_PANEL`
export const CLOSE_ARC_LIVE_PANEL = `${prefix}/CLOSE_ARC_LIVE_PANEL`

/** Shows a session's live transcript and Arc's triage in the side panel. */
export const openArcLivePanel = (sessionId: string) => ({
  type: OPEN_ARC_LIVE_PANEL,
  data: { sessionId },
})

export const closeArcLivePanel = () => ({ type: CLOSE_ARC_LIVE_PANEL })
